"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HBCornerBadge = void 0;
var _react = _interopRequireDefault(require("react"));
var _HBCornerBadge = require("./HBCornerBadge.styles");
var HBCornerBadge = exports.HBCornerBadge = function HBCornerBadge(_ref) {
  var _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'topRight' : _ref$position,
    content = _ref.content;
  return /*#__PURE__*/_react["default"].createElement(_HBCornerBadge.CornerBadgeWrapper, {
    position: position
  }, /*#__PURE__*/_react["default"].createElement(_HBCornerBadge.CornerBadgeSide, null), /*#__PURE__*/_react["default"].createElement(_HBCornerBadge.CornerBadgeText, {
    type: "emphasis12"
  }, content));
};
//# sourceMappingURL=HBCornerBadge.js.map